import Vue from "vue";
import Router from "vue-router";
import AuthLayout from "@/layouts/Auth";
import AppLayout from "@/layouts/App";
import store from "@/store";

Vue.use(Router);

const ACCESS = {
  EvenPartnerCanAccess : ["SaleChannelAdmin", "SaleChannelUser", "PartnerAdmin", "PartnerUser"],
  EvenRepresentativeCanAccess : ["SaleChannelAdmin", "SaleChannelUser", "PartnerAdmin", "PartnerUser", "RepresentativeAdmin", "RepresentativeUser"],
  EvenResellerCanAccess : ["SaleChannelAdmin", "SaleChannelUser", "PartnerAdmin", "PartnerUser", "RepresentativeAdmin", "RepresentativeUser", "ResellerAdmin", "ResellerUser"],
  
  OnlySaleChannelCanAccess : ["SaleChannelAdmin", "SaleChannelUser"],
  OnlyPartnerCanAccess : ["PartnerAdmin", "PartnerUser"],
  OnlyRepresentativeCanAccess : ["RepresentativeAdmin", "RepresentativeUser"],
  OnlyResellerCanAccess : ["ResellerAdmin", "ResellerAdmin"],
  OnlyMerchantCanAccess : ["MerchantAdmin", "MerchantUser"],

  OnlyAdminsCanAccess : ["SaleChannelAdmin", "PartnerAdmin", "RepresentativeAdmin", "ResellerAdmin"],

  OnlySystemAdminsCanAccess : ["SystemAdmin"],
};

const router = new Router({
  base: process.env.BASE_URL,
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [


    {
      path: "/merchant-contract/:id/view",
      meta: {
        title: "Empresas | Editar",
        roles: ACCESS.EvenResellerCanAccess
      },
      component: () => import("./views/merchant/contract")
    },

    {
      // TODO fazer funcao de enviar o user para uma pagina de sem autorizacao
      path: "/",
      redirect: to => {
        try {
          const role = store.getters.userRoles[0]; // Get the user's role
          
          // Merchant roles
          if (role === "MerchantAdmin" || role === "MerchantUser") {
            return "dashboard/analytics/ec";
          }
          
          // Partner roles
          if (role === "PartnerAdmin" || role === "PartnerUser") {
            return "dashboard/analytics/pt";
          }
          
          // Representative roles
          if (role === "RepresentativeAdmin" || role === "RepresentativeUser") {
            return "dashboard/analytics/rt";
          }
          
          // Reseller roles
          if (role === "ResellerAdmin" || role === "ResellerUser") {
            return "dashboard/analytics/rt"; // Redirecting to representative dashboard for now as there's no specific reseller dashboard
          }
          
          // Default for SaleChannelAdmin and other roles
          return "dashboard/analytics";
        } catch (e) {
          return "dashboard/analytics";
        }
      },
      component: AppLayout,
      meta: { authRequired: true, hidden: true },

      children: [

        // Partner
        {
          path: "/parceiros",
          meta: {
            title: "Parceiros",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/partner")
        },
        {
          path: "/parceiros/novo-parceiro",
          meta: {
            title: "Parceiros - Novo Parceiro",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/partner/edit")
        },
        {
          path: "/parceiros/editar-parceiro/:id",
          meta: {
            title: "Parceiros - Editar Parceiro",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/partner/edit")
        },

        // Support Tickets
        {
          path: "/atendimentos",
          meta: {
            title: "Tickets de Suporte",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/supportticket/manager/manager-index.vue")
        },
        {
          path: "/atendimentos/:id",
          meta: {
            title: "Tickets de Suporte - Editar Ticket",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/supportticket/manager/manager-edit.vue")
        },

        // Support Tickets
        {
          path: "/suporte",
          meta: {
            title: "Suporte"
          },
          component: () => import("./views/supportticket/customer/customer-index.vue")
        },
        {
          path: "/suporte/novo-chamado",
          meta: {
            title: "Suporte - Novo Chamado"
          },
          component: () => import("./views/supportticket/customer/customer-create")
        },
        {
          path: "/suporte/visualizar/:id",
          meta: {
            title: "Suporte - Visualizar Chamado"
          },
          component: () => import("./views/supportticket/customer/customer-visualize")
        },

        // Representative
        {
          path: "/representantes",
          meta: {
            title: "Representantes",
            roles: ACCESS.EvenPartnerCanAccess,
          },
          component: () => import("./views/representative")
        },
        {
          path: "/representantes/novo-representante",
          meta: {
            title: "Representantes - Novo Representante",
            roles: ACCESS.EvenPartnerCanAccess,
          },
          component: () => import("./views/representative/edit")
        },
        {
          path: "/representantes/editar-representante/:id",
          meta: {
            title: "Representantes - Editar Representante",
            roles: ACCESS.EvenPartnerCanAccess,
          },
          component: () => import("./views/representative/edit")
        },

        // Reseller
        {
          path: "/revendedores",
          meta: {
            title: "Revendedores",
            roles: ACCESS.EvenRepresentativeCanAccess,
          },
          component: () => import("./views/reseller")
        },
        {
          path: "/revendedores/novo-revendedor",
          meta: {
            title: "Revendedores - Novo Revendedor",
            roles: ACCESS.EvenRepresentativeCanAccess,
          },
          component: () => import("./views/reseller/edit")
        },
        {
          path: "/revendedores/editar-revendedor/:id",
          meta: {
            title: "Revendedores - Editar Revendedor",
            roles: ACCESS.EvenRepresentativeCanAccess,
          },
          component: () => import("./views/reseller/edit")
        },




        // ATIVOS
        {
          name: "device",
          path: "/maquinetas",
          meta: {
            title: "Maquinetas | Equipamentos",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/device")
        },

        {
          path: "/maquinetas/editar-maquineta/:id",
          meta: {
            title: "Ativos | Equipamentos",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/device/edit")
        },

        {
          path: "/maquinetas/adicionar-maquineta",
          meta: {
            title: "Ativos | Equipamentos",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/device/edit")
        },
        // Device Contract

        {
          name: "deviceRent",
          path: "/aluguel/contratos",
          meta: {
            title: "Gestão de Aluguel | Equipamentos",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/device/rental")
        },

        // PagSeguro
        {
          path: "/pagseguro/onboarding",
          meta: {
            title: "PagSeguro | Ativação Cliente",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/pagseguro/onboarding")
        },

        {
          path: "/pagseguro/aguardando-informacoes",
          meta: {
            title: "PagSeguro | Aguardando Informações",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/pagseguro/pending-information")
        },

        // Credenciamento
        {
          path: "/credenciamento/politica-comercial",
          meta: {
            title: "Credenciamento | Política Comercial",
            roles: ACCESS.EvenResellerCanAccess,
          },
          component: () => import("./views/credenciamento/politica-comercial")
        },
        {
          path: "/credenciamento/politica-comercial/adicionar",
          name: "politica-comercial-adicionar",
          meta: {
            title: "Credenciamento | Política Comercial | Adicionar",
            roles: ACCESS.EvenResellerCanAccess,
          },
          component: () => import("./views/credenciamento/politica-comercial/adicionar")
        },
        {
          path: "/credenciamento/politica-comercial/:id/editar",
          name: "politica-comercial-editar",
          meta: {
            title: "Credenciamento | Política Comercial | Editar",
            roles: ACCESS.EvenResellerCanAccess,
          },
          component: () => import("./views/credenciamento/politica-comercial/editar")
        },

        // Usuários
        {
          path: "/usuarios",
          props: true,
          meta: {
            title: "Usuários"
          },
          component: () => import("./views/user/index.vue")
        },

        {
          path: "/operacional/register",
          name: "operacional-register",
          props: true,
          meta: {
            title: "Time Operacional | Registro",
          },
          component: () => import("./views/operations/register")
        },



        // Estabelecimentos
        {
          path: "/estabelecimentos",
          meta: {
            title: "Empresas ",
            roles: ACCESS.EvenPartnerCanAccess
          },
          component: () => import("./views/merchant")
        },
        {
          path: "/estabelecimentos/contract-review",
          meta: {
            title: "Contrato Revisão  ",
            roles: ACCESS.EvenPartnerCanAccess,
          },
          component: () => import("./views/merchantcontract")
        },
        {
          path: "/estabelecimentos/:id/editar-estabelecimento",
          meta: {
            title: "Empresas | Editar",
            roles: ACCESS.EvenPartnerCanAccess,
          },
          component: () => import("./views/merchant/edit")
        },
        {
          path: "/estabelecimentos/adicionar-estabelecimento",
          meta: {
            title: "Empresas | Editar",
            roles: ACCESS.EvenPartnerCanAccess,
          },
          component: () => import("./views/merchant/edit")
        },
        // Estabelecimentos // Documentação Pendente





       
        {
          path: "/taxas",
          meta: {
            title: "Minhas Taxas",
            //roles: ACCESS.OnlyMerchantCanAccess,
          },
          component: () => import("./views/fee")
        },

        //invoice

        {
          path: "/faturas/estabelecimentos",
          meta: {
            title: "Faturas | Estabelecimentos",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/invoice")
        },

        {
          path: "/faturas/nova-fatura",
          meta: {
            title: "Fatura | Ec",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/invoice/new-invoice/index.vue")
        },
        {
          path: "/faturas/:id",
          meta: {
            title: "Fatura | Ec",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/invoice/edit-invoice/index.vue")
        },

        //Transações não sincronizadas

        {
          path: "/transactions-unsync",
          name: "transactions-unsync",
          meta: {
            title: "Transações não sincronizadas",
            roles: ACCESS.OnlySaleChannelCanAccess,
          },
          component: () => import("./views/transaction/unsync")
        },

        {
          path: "/transacoes/recapturar",
          name: "transactions-recapture",
          meta: {
            title: "Recapturar Transações",
            roles: ACCESS.OnlySaleChannelCanAccess,
          },
          component: () => import("./views/transaction/recapture")
        },

        {
          path: "/auditoria/suspeita-de-fraude",
          meta: {
            title: "Suspeita de Fraude",
            roles: ACCESS.EvenResellerCanAccess
          },
          component: () => import("./views/fraudanalisys")
        },

        // Recebimentos
        {
          path: "/recebimentos",
          name: "payoutlot",
          meta: {
            title: "Recebimentos ",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/payoutlot")
        },

        {
          path: "/conciliacao-pagamento",
          name: "conciliation",
          meta: {
            title: "Conciliação de Pagamentos ",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/paymentconciliation")
        },

        {
          path: "/transferencia-saldo",
          name: "transfer-to-main-account",
          meta: {
            title: "Transferência de Saldo",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/paymentconciliation/transfer")
        },


        {
          path: "/recebimentos/:id/edit",
          meta: {
            title: "Recebimentos",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/payoutlot/edit") 
        },

        {
          path: "/recebimentos/:id/receivables",
          meta: {
            title: "Recebimentos | Visualizar",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/payoutlot/receivables")
        },

        //Comissionamento

        {
          path: "/partnercomission",
          meta: {
            title: "Comissão",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/partnercomission")
        },

        // Credenciamento
        {
          path: "/parceiros/adquirentes",
          meta: {
            title: "Parceiros | Adquirentes",
            roles: ['SystemAdmin']
          },
          component: () => import("./views/partners/acquirer")
        },
        {
          path: "/parceiros/canais-de-venda",
          meta: {
            title: "Parceiros | Canais de Venda",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/partners/salechannel")
        },




        // SaleChannel
        {
          path: "parceiros/canais-de-venda/fatura",
          meta: {
            title: "Parceiros | Canais de Venda | Faturas",
            roles: ACCESS.OnlySaleChannelCanAccess
          },
          component: () => import("./views/partners/salechannel/salechannel-invoice/index")
        },

        // templates de emails
        {
          // listar
          path: "/email-templates",
          meta: {
            title: "Templates de E-mail | Lista",
            roles: ACCESS.EvenPartnerCanAccess
          },
          name: "email-templates",
          component: () => import("./views/email-templates/index")
        },
        {
          // editar
          path: "/email-templates/:id/edit",
          meta: {
            title: "Templates de E-mail | Editar",
            roles: ACCESS.EvenPartnerCanAccess
          },
          name: "email-templates-edit",
          component: () => import("./views/email-templates/editar")
        },
        {
          // adicionar
          path: "/email-templates/add",
          meta: {
            title: "Templates de E-mail | Adicionar",
            roles: ACCESS.EvenPartnerCanAccess
          },
          name: "email-templates-add",
          component: () => import("./views/email-templates/adicionar")
        },

        {
          path: "/dashboard/receivement",
          name: "dashboard-receivement",
          meta: {
            //roles: ACCESS.OnlyMerchantCanAccess,
            title: "Dashboard Recebimento"
          },
          component: () => import("./views/dashboard/receivement/receivement.vue")
        },

        {
          path: "/dashboard/performance/estabelecimento",
          name: "dashboard-performance-merchant",
          meta: {
            roles: ACCESS.EvenResellerCanAccess,
            title: "Dashboard Performance EC/Dia"
          },
          component: () => import("./views/dashboard/performance-merchant/index.vue")
        },

        {
          path: "/dashboard/performance/estabelecimento-mes",
          name: "dashboard-performance-merchant-mes",
          meta: {
            roles: ACCESS.EvenResellerCanAccess,
            title: "Dashboard Performance EC/Mês"
          },
          component: () => import("./views/dashboard/performance-merchant-m/index.vue")
        },



        {
          path: "/transaction/:transactionhash",
          name: "transaction-detail",
          meta: {
            title: "Detalhe da transação"
          },
          component: () => import("./views/transaction/index.vue")
        },

        // Financeiro
        // Financeiro // Liquidação
        // Financeiro // Liquidação // Cnab
        {
          path: "/liquidacao/overview",
          name: "liquidation-overview",
          meta: {
            roles: ACCESS.OnlySaleChannelCanAccess,
            title: "Liquidação Overview"
          },
          component: () => import("./views/liquidation/overview/index.vue")
        },

        {
          path: "/liquidacao/geracao-arquivo-remessa",
          name: "liquidation-cnab",
          meta: {
            roles: ACCESS.OnlySaleChannelCanAccess,
            title: "Gestão de Arquivos Cnab"
          },
          component: () => import("./views/liquidation/cnab/index.vue")
        },
        // Financeiro // Liquidação // CnabPayout
        {
          path: "/liquidacao/arquivo-remessa",
          name: "liquidation-payoutcnab",
          meta: {
            roles: ACCESS.OnlySaleChannelCanAccess,
            title: "Arquivos de Remessa"
          },
          component: () => import("./views/liquidation/cnabpayout/index.vue")
        },
        // Financeiro // Liquidação // CnabPayout // Detail
        {
          path: "/liquidacao/arquivo-remessa/:id",
          name: "liquidation-payoutcnab-detail",
          meta: {
            roles: ACCESS.OnlySaleChannelCanAccess,
            title: "Arquivos de Remessa"
          },
          component: () => import("./views/liquidation/cnabpayout/detail/index.vue")
        },

        // Financeiro // Concilição // Payout Conciliation
        {
          path: "/conciliacao/conciliacao-de-pagamentos",
          name: "conciliation-payoutConciliation",
          meta: {
            roles: ACCESS.OnlySaleChannelCanAccess,
            title: "Conciliação de Pagamentos"
          },
          component: () => import("./views/conciliation/payoutConciliation/index.vue")
        },
        // Financeiro // Concilição // Fluxo de Entradas e Saidas
        {
          path: "/conciliacao/fluxo-entrada-saida",
          name: "conciliation-in-out-flux",
          meta: {
            roles: ACCESS.OnlySaleChannelCanAccess,
            title: "Fluxo de Entradas e Saidas"
          },
          component: () => import("./views/conciliation/inOutFlux/index.vue")
        },


        // Relatórios
        // Relatórios // Device
        {
          path: "/relatorio/maquineta/ultima-transacao",
          name: "report-device-last-transaction",
          meta: {
            roles: ACCESS.EvenResellerCanAccess,
            title: "Relatório Última Transação Máquina"
          },
          component: () => import("./views/report/device/last-transaction/index.vue")
        },
        // Relatorio // Estabelecimentos
        {
          path: "/relatorio/estabelecimento/apuracao-de-faturamento",
          meta: {
            title: "Apuração de Faturamento | Estabelecimentos",
            roles: ACCESS.EvenResellerCanAccess,
          },
          component: () => import("./views/report/merchant/forecast")
        },
        // Relatorio // Estabelecimentos
        {
          path: "/relatorio/estabelecimento/documentacao-pendente",
          meta: {
            title: "Documentação Pendente | Estabelecimentos",
            roles: ACCESS.EvenResellerCanAccess,
          },
          component: () => import("./views/report/merchant/pending-files")
        },


        // Notificaçoes 
        {
          path: "/notification/contract",
          name: "notification-contract",
          meta: {
            roles: ACCESS.EvenResellerCanAccess,
            title: "Contrato Notificação"
          },
          component: () =>
            import("./views/notifications/sendcontract.vue")
        },

        // Auditoria
        // Eventos
        {
          path: "/auditoria/eventos",
          name: "audit-event",
          meta: {
            roles: ACCESS.OnlySaleChannelCanAccess,
            title: "Eventos de Auditoria"
          },
          component: () => import("./views/audit/events/index.vue")
        },

        // Configurações
        // Featuress
        {
          path: "/configuracoes/funcionalidades",
          name: "configuration-feature",
          meta: {
            roles: ACCESS.OnlySaleChannelCanAccess,
            title: "Funcionalidades"
          },
          component: () => import("./views/feature/index.vue")
        },

        {
          path: "/configuracoes/funcionalidades/aluguel",
          name: "configuration-feature-rent",
          meta: {
            roles: ACCESS.OnlySaleChannelCanAccess,
            title: "Gestão de Aluguel"
          },
          component: () => import("./views/feature/deviceRent/index.vue")
        },




        {
          path: "/autenticacao/impersonar",
          name: "authImpersonate",
          meta: {
            // roles: ACCESS.OnlySystemAdminsCanAccess,
            title: "Impersonar"
          },
          component: () => import("./views/auth/impersonate/index.vue")
        },


        // Dashboards
        {
          path: "/dashboard/analytics/ec",
          name: "dashboard-ec",
          meta: {
            roles: ACCESS.OnlyMerchantCanAccess,
            title: "Dashboard Analytics Merchant",
            authRequired: true,
            hidden: true
          },
          component: () => import("./views/dashboard/analytics/merchant")
        },
        {
          path: "/dashboard/analytics/pt",
          name: "dashboard-partner",
          meta: {
            roles: ACCESS.OnlyPartnerCanAccess,
            title: "Dashboard Analytics Parceiro",
          },
          component: () => import("./views/dashboard/analytics/partner")
        },
        {
          path: "/dashboard/analytics/rt",
          name: "dashboard-representative",
          meta: {
            roles: ACCESS.OnlyRepresentativeCanAccess,
            title: "Dashboard Analytics Representante",
          },
          component: () => import("./views/dashboard/analytics/representative")
        },

        {
          path: "/dashboard/analytics",
          meta: {
            title: "Dashboard Analytics",
            roles: ACCESS.OnlySaleChannelCanAccess,
          },
          component: () => import("./views/dashboard/analytics")
        },

        {
          path: "/dashboard/statistics",
          meta: {
            title: "Dashboard Statistics"
          },
          component: () => import("./views/dashboard/statistics")
        },
        {
          path: "/dashboard/ecommerce",
          meta: {
            title: "Dashboard Ecommerce"
          },
          component: () => import("./views/dashboard/ecommerce")
        },
        {
          path: "/dashboard/faturamento",
          meta: {
            title: "Dashboard Faturamento"
          },
          component: () => import("./views/dashboard/revenue")
        },
        // Ecommerce
        {
          path: "/ecommerce/dashboard",
          meta: {
            title: "Ecommerce Dashboard"
          },
          component: () => import("./views/ecommerce/dashboard")
        },
        {
          path: "/ecommerce/orders",
          meta: {
            title: "Ecommerce Orders"
          },
          component: () => import("./views/ecommerce/orders")
        },
        {
          path: "/ecommerce/product-catalog",
          meta: {
            title: "Ecommerce Product Catalog"
          },
          component: () => import("./views/ecommerce/product-catalog")
        },
        {
          path: "/ecommerce/product-details",
          meta: {
            title: "Ecommerce Product Details"
          },
          component: () => import("./views/ecommerce/product-details")
        },
        {
          path: "/ecommerce/cart",
          meta: {
            title: "Ecommerce Cart"
          },
          component: () => import("./views/ecommerce/cart")
        },

        // Widgets
        {
          path: "/widgets/general",
          meta: {
            title: "Widgets General"
          },
          component: () => import("./views/widgets/general")
        },
        {
          path: "/widgets/lists",
          meta: {
            title: "Widgets Lists"
          },
          component: () => import("./views/widgets/lists")
        },
        {
          path: "/widgets/tables",
          meta: {
            title: "Widgets Tables"
          },
          component: () => import("./views/widgets/tables")
        },
        {
          path: "/widgets/charts",
          meta: {
            title: "Widgets Charts"
          },
          component: () => import("./views/widgets/charts")
        },
        // Cards
        {
          path: "/cards/basic-cards",
          meta: {
            title: "Basic Cards"
          },
          component: () => import("./views/cards/basic-cards")
        },
        {
          path: "/cards/tabbed-cards",
          meta: {
            title: "Tabbed Cards"
          },
          component: () => import("./views/cards/tabbed-cards")
        },
        // Tables
        {
          path: "/tables/bootstrap",
          meta: {
            title: "Bootstrap Tables"
          },
          component: () => import("./views/tables/bootstrap")
        },
        {
          path: "/tables/antd",
          meta: {
            title: "Ant Design Tables"
          },
          component: () => import("./views/tables/antd")
        },
        // Charts
        {
          path: "/charts/chartistjs",
          meta: {
            title: "Chartist.js"
          },
          component: () => import("./views/charts/chartistjs")
        },
        {
          path: "/charts/chartjs",
          meta: {
            title: "Chart.js"
          },
          component: () => import("./views/charts/chartjs")
        },
        {
          path: "/charts/c3",
          meta: {
            title: "C3 Charts"
          },
          component: () => import("./views/charts/c3")
        },
        {
          path: "/charts/peity",
          meta: {
            title: "Peity"
          },
          component: () => import("./views/charts/peity")
        },
        // Icons
        {
          path: "/icons/feather-icons",
          meta: {
            title: "Feather Icons"
          },
          component: () => import("./views/icons/feather-icons")
        },
        {
          path: "/icons/fontawesome",
          meta: {
            title: "Fontawesome Icons"
          },
          component: () => import("./views/icons/fontawesome")
        },
        // Advanced
        {
          path: "/advanced/form-examples",
          meta: {
            title: "Form Examples"
          },
          component: () => import("./views/advanced/form-examples")
        },
        // 404
        {
          path: "/404",
          meta: {
            title: "Error 404"
          },
          component: () => import("./views/system/404")
        },
        {
          path: "/403",
          meta: {
            title: "Error 403"
          },
          component: () => import("./views/system/403")
        }
      ]
    },

    // System Pages
    {
      path: "/system",
      component: AuthLayout,
      redirect: "/system/login",
      children: [
        {
          path: "/system/login",
          meta: {
            title: "Login"
          },
          component: () => import("./views/auth/login")
        },
        {
          path: "/system/forgot-password",
          meta: {
            title: "Forgot Password"
          },
          component: () => import("./views/system/forgot-password")
        },
        {
          path: "/system/confirm-email",
          meta: {
            title: "Confirmar Email"
          },
          component: () => import("./views/system/confirm-email")
        },
        {
          path: "/system/reset-password",
          meta: {
            title: "Register"
          },
          component: () => import("./views/system/reset-password")
        },
        {
          path: "/system/lockscreen",
          meta: {
            title: "Lockscreen"
          },
          component: () => import("./views/system/lockscreen")
        },
        {
          path: "/system/403",
          meta: {
            title: "Error 403"
          },
          component: () => import("./views/system/403")
        },
        {
          path: "/system/404",
          meta: {
            title: "Error 404"
          },
          component: () => import("./views/system/404")
        },
        {
          path: "/system/500",
          meta: {
            title: "Error 500"
          },
          component: () => import("./views/system/500")
        }
      ]
    },

    // Redirect to 404
    {
      path: "*",
      redirect: "system/404",
      hidden: true
    }
  ]
});

// Add navigation error handling
const originalPush = router.push;
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
    return Promise.resolve(err);
  });
};

// Also handle router.replace
const originalReplace = router.replace;
router.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
    return Promise.resolve(err);
  });
};

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    // ainda estamos autenticados?
    if (!store.getters.isAuthenticated) {
      next({
        path: "/system/login",
        query: { redirect: to.fullPath }
      });
    } else {
      // estamos autenticados, mas temos permissao?

      let roles = [];
      try {
        if (typeof to.meta.roles !== "undefined") {
          roles = to.meta.roles;
        }
      } catch (e) {
        // TODO--
      }

      let permissao = false;

      // se o usuario eh sysadm ou se o menu nao possui roles definidas retorna true =)
      if (!store.getters.userRoles.includes("SystemAdmin") && roles.length > 0)
      {
        roles.forEach(papel => {
          permissao = permissao || store.getters.userRoles.includes(papel);
        });
      } else {
        permissao = true;
      }
      if (permissao) {
        next();
      } else {
        next({
          path: "/403"
        });
      }
    }
  } else {
    next();
  }
});

export default router;
